import ExposureFlags from "./ExposureFlags";
import TextNote from "components/common/TextNote";
import Visible from "components/common/Visible";
import StateLaw from "components/inputs/flags/StateLaw";
import UWJudgment from "components/inputs/flags/UWJudgment";
import { COVERAGE_NOTES } from "flags";
import React from "react";

export const Flags = () => {
  return (
    <>
      <Visible byTag={"input.flags.uwJudgement"} defaultVisible>
        <UWJudgment />
      </Visible>
      <Visible byTag={"input.flags.exposureFlags"} defaultVisible>
        <ExposureFlags />
      </Visible>
      <Visible byTag={"input.flags.stateLaw"} defaultVisible>
        <StateLaw />
      </Visible>
      <Visible byTag={COVERAGE_NOTES} defaultVisible={false}>
        <TextNote title={"Coverage Notes"} noteKey={"coverageNotes"} />
      </Visible>
    </>
  );
};

export default Flags;
